import { Directive, DirectiveBinding } from 'vue';

const observerOptions = {
  root: null,
  rootMargin: '0px',
  threshold: 0,
};

const observers = new WeakMap<Element, IntersectionObserver>();

function createObserver(binding: DirectiveBinding): IntersectionObserver {
  return new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        binding.value();
      }
    });
  }, observerOptions);
}

const vIntersectionObserver: Directive = {
  mounted: (el: Element, binding) => {
    if (!el) {
      return;
    }
    const observer = createObserver(binding);
    observers.set(el, observer);
    observer.observe(el);
  },

  unmounted: (el: Element) => {
    observers.get(el)?.unobserve(el);
    observers.delete(el);
  },
};

export default vIntersectionObserver;
